import { createApp } from 'vue';
import App from './App.vue'; // App component should be the root component
import router from './router'; // Import the router configuration

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import BootstrapVue3 from 'bootstrap-vue-3';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/global.css';
import { isLoggedIn } from './utils/auth.js';
import VueGtag from "vue-gtag";

import Toast from 'vue-toastification';
import "vue-toastification/dist/index.css";

// **Import Vue Toastification** and its styles


// Create the Vue app and use the router
const app = createApp(App); // Use App as the root component
app.use(Toast, {
  position: 'top-right',  // Customize the position
  timeout: 3000,          // Duration of the toast
  closeOnClick: true,
  pauseOnHover: true,
});

// **Install Vue Gtag for Google Analytics**
app.use(VueGtag, {
  config: { id: "G-BF8HH7K0PL" }
}, router);

// **Add global property to check if the user is logged in**
app.config.globalProperties.$isLoggedIn = isLoggedIn;

// Apply BootstrapVue and Vue Router
app.use(BootstrapVue3);
app.use(router); // Use the router

// Mount the app
app.mount('#app');
